<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    :fullscreen="$vuetify.display.smAndDown"
    scrollable
    :retain-focus="false"
  >
    <v-card flat tile color="grey-darken-4" class="video-dialog-card">
      <v-card-title class="redColor video-dialog-title d-flex align-center ga-2 pa-3">
        <v-btn variant="text" icon color="white" class="flex-shrink-0" @click="download">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          size="small"
          color="white"
          class="video-dialog-close-btn flex-shrink-0"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <video
          v-if="source"
          ref="video"
          controls
          playsinline
          :src="source"
          class="video-dialog-player"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    source: null,
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.source = null;
        this.$emit("close");
      }
    },
  },
  methods: {
    open(video) {
      if (video.type === "string")
        this.source = `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${video.data}`;
      else if (video.type === "blob")
        this.source = URL.createObjectURL(video.blob);
      else this.source = null;
      this.dialog = true;
    },
    close() {
      this.source = null;
      this.dialog = false;
      this.$emit("close");
    },
    async download() {
      const { video } = this.$refs;
      if (!video?.currentSrc) return;

      const response = await fetch(video.currentSrc);
      const blob = await response.blob();

      let filename = "video";
      const contentDisposition =
        response.headers.get("content-disposition") || "";
      const cdMatch =
        contentDisposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i) ||
        contentDisposition.match(/filename="?([^"]+)"?/i);
      if (cdMatch?.[1]) {
        filename = decodeURIComponent(cdMatch[1].trim());
      }
      try {
        const url = new URL(video.currentSrc, window.location.href);
        const lastSegment = url.pathname.split("/").filter(Boolean).pop();
        if (!cdMatch?.[1] && lastSegment)
          filename = decodeURIComponent(lastSegment);
      } catch {
        // ignore invalid URL parsing (e.g. some blob URLs)
      }

      const contentType = (
        response.headers.get("content-type") || ""
      ).toLowerCase();
      const inferredExt = contentType.includes("video/webm")
        ? "webm"
        : contentType.includes("video/quicktime")
          ? "mov"
          : contentType.includes("video/ogg")
            ? "ogv"
            : contentType.includes("video/mp4")
              ? "mp4"
              : "";

      const extMatch = filename.match(/\.([a-z0-9]{2,5})$/i);
      const currentExt = extMatch?.[1]?.toLowerCase() || "";

      // If missing extension, add one. If it's `.bin`, replace with a video ext.
      if (!currentExt) {
        filename = `${filename}.${inferredExt || "mp4"}`;
      } else if (currentExt === "bin") {
        filename = filename.replace(/\.bin$/i, `.${inferredExt || "mp4"}`);
      }

      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = filename;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);
    },
  },
};
</script>

<style scoped>
.video-dialog-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.video-dialog-player {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: calc(100vh - 80px);
  background: #000;
}

@media (max-width: 959.98px) {
  .video-dialog-title {
    position: relative;
    padding-right: 52px !important;
  }

  .video-dialog-close-btn {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }

  .video-dialog-player {
    max-height: calc(100dvh - 64px);
  }
}
</style>
